import React from 'react';

interface PaymentsIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

const PaymentsIcon: React.FC<PaymentsIconProps> = ({
  width = 31,
  height = 32,
  color = 'currentColor',
  className,
  style,
  title,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="4 1 31 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role="img"
    aria-hidden={title ? undefined : true}
  >
    {title ? <title>{title}</title> : null}

    <path
      d="M28.59 10.23c-1.57.92-3.04 2.03-4.43 3.2-1.5 1.27-3 2.58-4.38 3.99-.51.52-1.01 1.06-1.48 1.62-.1.12-.21.24-.31.37-.47-2.24-1.33-4.43-2.7-6.21l-.17-.24c-1.27-1.56-3.85 2.03-2.76 3.36 1.72 2.11 2.6 4.97 2.83 7.65.05.58.31.91.66 1.04.4.15.92.02 1.39-.38 1.26-1.09 2.06-2.58 3.16-3.82 1.19-1.35 2.6-2.5 3.95-3.68 2.63-2.3 5.48-4.37 8.97-5.07 1.02-.2 1.76-1.46 1.94-2.4.07-.36.04-.75-.09-1.05-.17-.4-.52-.67-1.09-.55-.81.16-1.59.4-2.36.68l-.13.04c-1.04.39-2.03.88-2.99 1.44Z"
      fill={color}
    />

    <path
      d="M18.14 34.97c-.48 0-.96-.12-1.4-.37-.53-.3-12.93-7.33-12.93-12.99v-12.8c0-1.19.72-2.24 1.83-2.67 2.73-1.06 9.33-3.63 11.47-4.46.67-.26 1.4-.26 2.07 0l11.17 4.9c.73.27-.08.51-.65.73-.5.19-1.09.51-1.58.31l-9.63-4.13c-.22-.08-.44-.08-.66 0-2.14.83-8.74 3.4-11.47 4.46-.36.14-.59.48-.59.86v12.8c0 3.47 8.04 9.12 11.94 11.3.28.16.62.16.9 0 3.9-2.19 11.94-7.83 11.94-11.3v-6.28c0-.53.51-.7.97-.97.53-.31.97-.7.97-.17v7.42c0 5.67-12.4 12.7-12.93 12.99-.44.25-.92.37-1.4.37Z"
      fill={color}
    />

    <path
      d="M18.13 31.12c-.43 0-1.32-.54-1.44-.98-.13-.52.6-.23 1.37-.69 1.13-.47 9.52-5.61 9.52-8.48l.02-3.33c0-.53-.05-.81.37-1.14.5-.4 1.07-1.04 1.07-.51v4.76c0 4.6-10.18 10.21-10.67 10.33-.08.02-.16.03-.24.03Z"
      fill={color}
    />

    <path
      d="M7.38 21.55c-.14-.2-.16-.71-.16-1.24v-8.76c0-1.19.72-2.24 1.82-2.67 2.83-1.1 8.41-3.27 8.72-3.39.23-.1.5-.1.74 0l7.53 3.39c.5.2-.14.28-.49.5-.45.29-.61.38-1.11.18l-6.47-2.48c-.98.42-3.5 1.25-8.22 3.62-.34.17-.59.48-.59.86l-.43 9.93c0 1.29-.8.58-1.34.07Z"
      fill={color}
    />
  </svg>
);

export default PaymentsIcon;
